import React from 'react';
import styled from 'styled-components'
import moment from 'moment'
import {
  Link,
} from "react-router-dom";

const WrapperProfile = styled(Link)`
  outline: none;
  text-decoration: none;
  color: inherit;

  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;

  padding: 0 0.8rem;
`

const Avatar = styled.div`
 display: flex;
 align-content: center;

  img {
    border-radius: 50%;
    border: 1px solid #d8d8d8;
    
  }
`

const WrapperInfo = styled.div`
  display: flex;
  flex-direction: column;

  flex-grow: 1;
  margin: 0 0.7rem;

 
  align-items: flex-start;

`

  const Name = styled.p`
    font-size: 0.9em;
    font-weight: 400; 
    color: #373D3F;
  `

  const City = styled.p`
    font-size:  0.8em;
    font-weight: 300;
    color: #8C979A;
  `

const Date = styled.p`
  font-size:  0.7em;
  font-weight: 300;
  color: #555F61;
`

const undefinedClient = {
  name: 'Welcome back!',
  city: '',
  avatar: 'https://robohash.org/Y45.png?set=set1&size=50x50',
  clientfrom: Math.floor(window.Date.now() / 1000),
  orders: [],
  id: { $oid: ''}
}

export default function cardClientsProfile ({type, client = undefinedClient}) {
  const {name, city, avatar, clientfrom, id: { $oid }} = client

  return (
    <WrapperProfile to={`/clients/${$oid}`}>
      <Avatar><img alt='Client avatar' width="50" height="50" src={avatar}></img></Avatar>
      <WrapperInfo><Name>{name}</Name><City>{city}</City></WrapperInfo>
      <Date>{type === 'New Clients' ? moment.unix(clientfrom).format("MMM Do Y") : calculateSumSpent(client)}</Date>
    </WrapperProfile>
  )
}

function calculateSumSpent({orders}) {
  let totA = 0
  for (let i = 0; i < orders.length; i++) {
    let nPrice = Number(orders[i].price.replace(/[^0-9.-]+/g,""))
    let curOrder = nPrice * orders[i].days
    totA = totA + curOrder
  }
  return `$${Math.floor(totA)}`
}
